var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2025-08-28T09:49:31-8e6607d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["clashofclans-inbox@supercell"]={id:"2025-08-28T09:49:31-8e6607d"};
      